import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    style: translate({ id: 'rm.contextual.route.style' }),
    styleAll: translate({ id: 'rm.contextual.route.styleAll' }),
  }))

  return api
}
